export default "__VITE_ASSET__140NiCLR__"